import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LoginSignup from '../views/LoginSignup.vue'
import Join from '../views/Join.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'LoginSignupRoute',
    component: LoginSignup,
  },
  {
    path: '/join',
    name: 'JoinRoute',
    component: Join,
  },
  {
    path: '/cancel',
    name: 'Cancel',
    component: () => import('../views/Cancel.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/Success.vue')
  },
  {
    path: '/leaderboard',
    name: 'LeaderboardRoute',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Leaderboard.vue')
  },
  {
    path: '/oauth/callback',
    name: 'OAuthCallbackView',
    component: () => import('../views/OAuthCallbackView'),
  },
  {
    path: '/oauth/in-app',
    name: 'OAuthInAppView',
    component: () => import('../views/AppEntry.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
